// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"e9a37da7","361":"55d67b32","767":"5c8f9ec2"}[chunkId] + ".chunk.js";
};